import * as React from 'react';
import styled, { css } from 'styled-components';
import { format } from 'date-fns';
import { Text, Badge } from 'unbrace/components';
import { NotificationStatus } from '../types';

type Props = {
  message: string;
  timeStamp: Date;
  status: string;
  markAsReadResource: string;
  onMarkAsRead: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const NotificationWrapper = styled.div<{ isNew: boolean }>`
  padding: ${(props) => props.theme.notifications.padding.main};
  display: flex;
  flex-direction: column;
  position: relative;

  > p {
    margin-bottom: 4px;
    word-break: break-word;
  }

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    transition: all 0.25s ease-in;
  }

  > a {
    position: absolute;
    opacity: 0;
    bottom: 0;
    left: 0;
    text-decoration: none;
    transition: all 0.25s ease-in;
    padding: ${(props) => props.theme.notifications.padding.main};
    padding-bottom: 4px;
  }

  &:hover {
    background: ${(props) => props.theme.notifications.background.hover};

    ${(props) =>
      props.isNew &&
      css`
        > div {
          margin-bottom: 24px;
          transition: all 0.15s 0.4s ease-in;
        }

        > a {
          opacity: 1;
          transform: translate(0, -8px);
          transition: all 0.15s 0.4s ease-in;
        }
      `}
  }
`;

export const Notification: React.FC<Props> = ({ message, timeStamp, status, markAsReadResource, onMarkAsRead }) => (
  <NotificationWrapper isNew={status === NotificationStatus.New}>
    <Text color="neutral" asTag="p" size="s">
      {message}
    </Text>
    <div>
      <Text color="neutral" colorLevel="medium" asTag="span" size="xs">
        {format(timeStamp, 'ddd - DD/MM/YYYY - HH:mm:ss')}
      </Text>
      <Badge color={status === NotificationStatus.New ? 'primary' : 'secondary'} size="xsmall">
        {status}
      </Badge>
    </div>
    <a href="/" onClick={onMarkAsRead}>
      <Text color="primary" colorLevel="medium" asTag="span" size="xxs">
        {markAsReadResource}
      </Text>
    </a>
  </NotificationWrapper>
);
